<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        .card: .card--body
          .heading--section Memorandum of Understanding (MoU) Announcements
          
          Loading(:isLoading="isDataLoading", type="bar")
            DataTable.mt-4(
              :displayPagination="false",
              :displayItemsPerPage="false",
              :records="mous_processed", 
              :headers="headers", 
              :emptyDisplayMessage="`No records found.`",
            )
              template(v-slot:slot-for-description="item")
                template(v-if="item.record.url")
                  a.text__uppercase.link__primary_light(:href="item.record.url", target="_blank") {{ item.record.description }}
                template(v-else)
                  | {{ item.record.description }}
</template>



<script>
import * as moment from 'moment';
import requestHandlers from '../../mixins/requestHandlers';
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';

export default {
  name: 'Mou',

  mixins: [requestHandlers],

  components: {
    Loading,
    DataTable
  },

  data() {
    return {
      mous: [],

      headers: [
        {
          id: 'date',
          text: 'Date',
          sortable: true,
          type: 'string',
          colAlignment: 'left',
          colWidth: 10,
        },
        {
          id: 'counter',
          text: 'Stocks',
          sortable: true,
          type: 'counter',
          colWidth: 15,
          colAlignment: 'center'
        },
        {
          id: 'description',
          text: 'Description',
          sortable: false,
          type: 'custom_slot',
          colAlignment: 'left',
        },
      ]
    }
  },



  computed: {
    mous_processed() {
      return this.mous.map(stock => {
        let _obj = {
          description: stock.attributes.description,
          url: stock.attributes.url,
          date: moment(stock.attributes.date).format('YYYY-MM-DD'),
          counterDto: {
            code: stock.attributes.counter.data[0].attributes.code,
            name: stock.attributes.counter.data[0].attributes.name,
          }
        }
        return _obj;
      });
    }
  },



  methods: {
    FETCH_RECORDS() {
      this.REQUEST_INIT();

      this.$axios.get('/News/Mou')
      .then(response => {

        if(response.status !== 200) {
          return;
        }
        this.mous = response.data.data.data;
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    },

  },


  created() {
    this.FETCH_RECORDS();
  },

}

</script>




<style lang="scss">

</style>
